"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var item_type_enum_1 = require("../constants/item-type.enum");
/**
 * Item represents the item json object in the assessment template table
 *
 * @property {string}                   externalId     - unique item identifier
 * @property {string}                   externalId     - unique item identifier at the item bank, this is used to render responses
 * @property {string}                   title          - title
 * @property {string}                   description    - description
 * @property {string[]}                 standards      - question standards
 * @property {string[]}                 childStandards - question child standards
 * @property {string}                   dok            - depth of knowledge
 * @property {boolean}                  manualScoring  - Autoscorable: true / open ended:false
 * @property {number}                   maxScore       - max score
 * @property {Question}                 questions      - questions
 * @property {ItemType}                 type           - type
 * @property {ScoringType}              scoringType    - scoring type
 * @property {label}                    label          - item label
 * @property {string}                   foundational   - foundational
 * @property {StandardsByHierarchy[]}   standardHierarchyLevel - standards by hierarchy level
 *
 * @author javier.perez
 */
var isString_1 = __importDefault(require("lodash/isString"));
var scoring_type_enum_1 = require("../constants/scoring-type.enum");
var Item = /** @class */ (function () {
    function Item(item) {
        if (item === void 0) { item = {}; }
        Object.assign(this, item);
    }
    Object.defineProperty(Item.prototype, "isBranch", {
        get: function () {
            return this.type === item_type_enum_1.ItemType.Branch;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Indicate if any of the questions have rubrics
     */
    Item.prototype.hasRubricReferences = function () {
        var _a;
        return (_a = this.questions) === null || _a === void 0 ? void 0 : _a.some(function (_a) {
            var rubricReference = _a.rubricReference;
            return (0, isString_1.default)(rubricReference);
        });
    };
    /**
     * Indicate if an items is rubric and also have the scoring type passage
     */
    Item.prototype.isPassageScoringType = function () {
        return this.hasRubricReferences() && this.scoringType === scoring_type_enum_1.ScoringType.Passage;
    };
    /**
     * Indicate if an items is rubric and also have the scoring type matrix
     */
    Item.prototype.isMatrixScoringType = function () {
        return this.hasRubricReferences() && this.scoringType === scoring_type_enum_1.ScoringType.Matrix;
    };
    /**
     * Indicate if an items has rating scoring
     */
    Item.prototype.isRatingScoringType = function () {
        return this.hasRubricReferences() && this.scoringType === scoring_type_enum_1.ScoringType.Rating;
    };
    Item.prototype.hasStandardsByHierarchy = function (standardHierarchyLevel, standard) {
        var _a;
        return (((_a = this.standardsByHierarchy) === null || _a === void 0 ? void 0 : _a.filter(function (standardValue) {
            var _a;
            return standardValue.hierarchyLevel === standardHierarchyLevel &&
                ((_a = standardValue.standardGlobalIds) === null || _a === void 0 ? void 0 : _a.indexOf(standard)) >= 0;
        }).length) > 0);
    };
    return Item;
}());
exports.Item = Item;
